<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_gameWithTime') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='gameTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                        v-model='selectedGameType',
                        @select='params.withTime = $event.withTime'
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_viewTypeLeft') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='viewTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseViewType')",
                        v-model='leftColumnView',
                        @select='params.leftColumn = $event.type'
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_viewTypeRight') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='viewTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseViewType')",
                        v-model='rightColumnView',
                        @select='params.rightColumn = $event.type'
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.amountOfPairs",
                        :max="amountOfPairs",
                        :min="3",
                        @increase="increaseAmountOfPairs",
                        @decrease="decreaseAmountOfPairs",
                        @input="params.amountOfPairs = $event",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.numOfExamples",
                        :max="numOfExamples",
                        :min="1",
                        @increase="increaseNumOfExamples",
                        @decrease="decreaseNumOfExamples",
                        @input="params.numOfExamples = $event",
                    )
            .form__field(v-if="params.withTime && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_pairShowTime') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds"
                        v-model="params.showTime"
                        :placeholder="secondsLabel(params.showTime)"
                        :custom-label="secondsLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field(v-if="params.leftColumn === 'word' || params.rightColumn === 'word'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_difficultWords') }}
                .form__field-body
                    cs-checkbox(
                        v-model='params.difficultWords'
                    )
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame')
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _ from "lodash";
    import IntervalConfig from "../../trainer/configs/IntervalConfig";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                gameTypes: [
                    {
                        name: this.$i18n.t('common.common_gameName_couplesWithoutTime'),
                        withTime: false
                    },
                    {
                        name: this.$i18n.t('common.common_gameName_couplesWithTime'),
                        withTime: true
                    }
                ],
                gameModes: [
                    {
                        name: this.$i18n.t('couples.couples_gameMode_allTogether'),
                        mode: 'allTogether'
                    },
                    {
                        name: this.$i18n.t('couples.couples_gameMode_inTurn'),
                        mode: 'inTurn'
                    }
                ],
                viewTypes: [
                    {
                        name: this.$i18n.t('couples.couples_view_images'),
                        type: 'image'
                    },
                    {
                        name: this.$i18n.t('couples.couples_view_word'),
                        type: 'word'
                    },
                    {
                        name: this.$i18n.t('couples.couples_view_phrase'),
                        type: 'phrase'
                    }
                ],
                amountOfPairs: 100,
                numOfExamples: 15,
                seconds: IntervalConfig.secondsForMemoryGames,
                selectedGameType: null,
                rightColumnView: null,
                leftColumnView: null,
                selectedGameMode: null,
                params: null,
            }
        },
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedGameType = _.find(this.gameTypes, { withTime: this.params.withTime });
            this.rightColumnView = _.find(this.viewTypes, { type: this.params.rightColumn });
            this.leftColumnView = _.find(this.viewTypes, { type: this.params.leftColumn });
            this.selectedGameMode = _.find(this.gameModes, { mode: this.params.mode });
        },
        updated () {
            this.selectedGameType = _.find(this.gameTypes, { withTime: this.params.withTime });
            this.rightColumnView = _.find(this.viewTypes, { type: this.params.rightColumn });
            this.leftColumnView = _.find(this.viewTypes, { type: this.params.leftColumn });
            this.selectedGameMode = _.find(this.gameModes, { mode: this.params.mode });
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
        },
        watch: {
            'params.withTime': {
                handler (val) {
                    if (!this.params.showTime && val) {
                        this.params.showTime = this.seconds[0];
                        this.selectedGameMode = this.gameModes.find(item => item.mode === 'inTurn');
                        this.params.mode = this.selectedGameMode.mode;
                    } else if (!val) {
                        this.params.showTime = null;
                        this.selectedGameMode = this.gameModes.find(item => item.mode === 'allTogether');
                        this.params.mode = this.selectedGameMode.mode;
                    }
                }
            },
        },
        methods: {
            secondsLabel (second) {
                return second + " " + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds')
            },
            decreaseAmountOfPairs() {
                if (this.params.amountOfPairs !== 1) {
                    this.params.amountOfPairs -= 1;
                }
            },
            increaseAmountOfPairs() {
                if (this.params.amountOfPairs !== this.amountOfPairs) {
                    this.params.amountOfPairs += 1;
                }
            },
            decreaseNumOfExamples() {
                if (this.params.numOfExamples !== 1) {
                    this.params.numOfExamples -= 1;
                }
            },
            increaseNumOfExamples() {
                if (this.params.numOfExamples !== this.numOfExamples) {
                    this.params.numOfExamples += 1;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

